export const dataIsEmptyMessages: string[] = [
	'Currently, there is no data available for this widget.',
	'Please refresh the widget once students have test sessions, or adjust your filters to ensure data is properly displayed.',
];
